import React from 'react';
import { zonedTimeToUtc } from 'date-fns-tz';
import PopupFooter from './PopupFooter';
import { getOne } from '../BackendProvider';

class PopupBody extends React.Component {
    constructor (props) {
        super(props)
        this.state = {
            data: [],
            error: '',
            loading: false
        }
    }
    componentDidMount() {
        this.loadFromServer();
    }
    loadFromServer() {
        this.setState({loading: true})
        getOne(this.props.url, this.props.id).then(
            response => 
            this.setState({
                loading: false,
                data: response.data.data
            })
        );
    }
    
    render() {
        const {data} = this.state;
        const {prefs} = this.props;
        return(
            <div>
                <table className='table  table-striped'>
                    <tbody>
                {
                    this.props.fields.map(function (datarow, i) {
                        let value = <div >{data?.[datarow.source]}</div>;
                        if( datarow.type === 'enum' ) {
                            value = <div>{datarow.values[data[datarow.source]]}</div>;
                        } else if (datarow.type === 'datetimefull') {
                            try {
                                const utcTime = zonedTimeToUtc(new Date(data[datarow.source]),"UTC");
                                value = <div>{utcTime.toLocaleString(prefs.locale,{timeZoneName:'short', timeZone: prefs.tz})}</div>
                            } catch (err) {
                                value = <div>{data[datarow.source]}</div>
                            }
                        }
                        return (
                            <tr id={i} key={i}>
                                <td>
                                    {datarow.label}
                                </td>
                                <td>
                                    { value }
                                </td>
                            </tr>
                        )
                    }, this)
                }
                    </tbody>
                </table>
                <PopupFooter footer= {this.props.footer} fields = {this.props.fields} data = {this.state.data} />
            </div>
        )
    }
}

export default PopupBody;